<template>
  <div>
    <div v-for="blockData in blocksData" :key="blockData?.id">
      <GenericBlock
        :component-type="blockData.__typename"
        :content="blockData"
      />
    </div>
  </div>
</template>

<script setup>
const { locale } = useI18n()
const pageData = await useStrapiPage({
  slug: 'employee-gifts_en-us',
  locale: convertLocaleIntoBCP47(locale.value),
})
const blocksData = computed(() => pageData?.data?.value?.pages?.[0]?.contents)
definePageMeta({
  layout: 'default-max-screen',
  preloaderType: 'strapi',
})
</script>
